import { Dispatch, ReactElement, ReactNode, SetStateAction } from 'react'
import styled from 'styled-components'
import { Text } from '../../general'
import Avatar from '../../atoms/Avatar'
import { Popover } from 'antd'

type ImageBouquetProps = {
  images: string[]
  maximumRenderedItems: number
  popoverContent?: ReactNode
  open?: boolean
  openChangeFunction?: Dispatch<SetStateAction<boolean>>
}

const ImageBouquet = ({
  images,
  maximumRenderedItems,
  popoverContent,
  open,
  openChangeFunction,
}: ImageBouquetProps): ReactElement => {
  const renderedImages = images
    .filter(Boolean)
    .concat(images.filter((url) => !url))
    .slice(0, maximumRenderedItems)
  const remainingImages = images.length - maximumRenderedItems
  const overlap = 18
  const bouquetWidth =
    Math.min(maximumRenderedItems, renderedImages.length) * overlap + overlap

  return (
    <Popover
      placement="bottomLeft"
      onOpenChange={openChangeFunction}
      open={!popoverContent ? false : open}
      showArrow
      content={popoverContent}
      trigger="hover"
    >
      <Wrapper>
        <BouquetContainer width={bouquetWidth}>
          {renderedImages.map((image, index) => (
            <ImageContainer
              key={image}
              zIndex={renderedImages.length - index}
              overlap={overlap}
            >
              <Avatar size={36} url={image} />
            </ImageContainer>
          ))}
        </BouquetContainer>
        {remainingImages > 0 && (
          <RemainingImagesText level={1} weight="regular">
            {`+${remainingImages}`}
          </RemainingImagesText>
        )}
      </Wrapper>
    </Popover>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
`

const BouquetContainer = styled.div<{ width: number }>`
  display: flex;
  width: ${(props) => props.width}px;
  padding-left: 18px;
`

const ImageContainer = styled.div<{ zIndex: number; overlap: number }>`
  width: 36px;
  height: 36px;
  z-index: ${(props) => props.zIndex};
  border-radius: 100px;
  overflow: hidden;
  margin-left: -${(props) => props.overlap}px;
`

const RemainingImagesText = styled(Text)`
  margin: 0 8px;
  color: ${({ theme }) => theme.color.neutral.color5};
`

export default ImageBouquet
